import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-link bg-warning btn-lg d-flex align-items-center justify-content-center text-decoration-none el-scale bg-opacity-05",
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
    style: {"width":"56px","height":"56px"}
  }, [
    _createVNode(_component_IconComponent, {
      lib: 'filoxenia',
      icon: 'ArrowBack'
    })
  ]))
}